// fetching exam analysis data
export const FETCH_EXAM_ANALYSIS = "FETCH_EXAM_ANALYSIS";
export const FETCH_EXAM_ANALYSIS_SUCCESS = "FETCH_EXAM_ANALYSIS_SUCCESS";
export const FETCH_EXAM_ANALYSIS_ERROR = "FETCH_EXAM_ANALYSIS_ERROR";

// clear exam analysis
export const CLEAR_EXAM_ANALYSIS = "CLEAR_EXAM_ANALYSIS";